import DropLocation from './DropLocation'

export default DropLocation
